import { injectApp } from "@/lib";

import App from "./login.vue";

injectApp(App, true);
